/*
* Utility function to Santize CTA URL

JH's brief:
utm_source=revolution-viewing
* This will always be the same as the traffic will always be coming from us kind souls
utm_medium=referral
* For now, this will always be the same, it just means that the link has come from a referral (from us).
utm_campaign=virtual-tour
* Hopefully fairly self explanatory; this is the name of the campaign. For us, it will nearly always be set to be virtual-tour. The idea is if you were sending a newsletter this might say "july-19-newsletter" etc.
utm_content=logo-click
* This is the only bit that will need changing regularly. I feel values should be "logo-click", "tier-1-cta", "tier-2-cta", "social-link".
* The tiering of CTAs is so that they can see the difference between traffic from the designated CTA areas and then those that appear as secondary level links in text etc, for example "find out more about mathematics".

CM:
I've also added "legal", and "rv-acknowledgement" to utm_content.
*/
const { utm_campaign_slug } = require('@/../data.json') || {}

export default {
  methods: {
    utmHref(inputHref, type) {
      // Type should be logo-click, tier-1-cta, tier-2-cta, social-link, legal, rv-acknowledgement, external-link-card
      const utmQueries = `utm_source=revolution-viewing&utm_medium=referral&utm_campaign=${utm_campaign_slug}&utm_content=${type}`
      if (!inputHref) { return '' }
      const inputHrefHasQuery = inputHref.indexOf('?') !== -1
      return `${inputHref}${inputHrefHasQuery ? '&' : '?'}${utmQueries}`
    }
  }
}
